import React, { Component } from 'react';
import 'react-select/dist/react-select.css';
import styled from 'styled-components';
import FiatCurrencySelector from '../FiatCurrencySelector';
import axios from 'axios';
import SwitcharooIconLeft from 'react-icons/lib/fa/chevron-left';
import SwitcharooIconRight from 'react-icons/lib/fa/chevron-right';
import AdSense from 'react-adsense';
import { COLORS } from '../utils/style-utils';

const fx = require('money');

const ConverterContainer = styled.div`
  margin: 0 auto;
  font-family: 'verdana', 'sans-serif' !important;
`;

const ColorBox = styled.div`
  background-color: ${props => props.bg};
  padding: 20px;
  max-width: ${props => props.maxWidth};
  margin: 0 auto;
`;

const CheatCheetTitle = styled.h4`
  text-align: center;
  color: ${COLORS.DARK_BLUE};
`;

const FieldContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 20px 0;
  align-items: center;
`;

const CurrencyField = styled.input`
  padding: 5px;
  display: flex;
  width: 100%;
  border: 3px solid #fff;
  border-radius: 3px;
  font-size: 16px;
  color: #111;
`;

const SwitcharooButton = styled.button`
  cursor: pointer;
  background: none;
  border: 1px solid #fff;
  color: #fff;
  margin: 0 10px;
  display: flex;
  font-size: 12px;
  border-radius: 3px;
  padding: 5px 8px;

  &:hover {
    background: #fff;
    color: ${COLORS.EMERALD_GREEN};
  }
`;

const CurrencyLabel = styled.span`
  font-size: 20px;
  display: inline-block;
  margin-right: 10px;
  color: #fff;
  width: 50px;
`;

const ControlsContainer = styled.div`
  display: flex;
`;

const QuoteCurrencyOutput = styled.span`
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #fff;
  padding-bottom: 2px;
  display: flex;
  width: 100%;
`;

const CurrencyTable = styled.table`
  margin: 0 auto;
  border: solid 1px ${COLORS.DARK_BLUE} !important;
  border-left: none;
  border-right: none;
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  max-width: 540px;

  & tbody td {
    border: solid 1px ${COLORS.DARK_BLUE} !important;
    color: ${COLORS.DARK_BLUE};
    padding: 10px !important;
    text-align: center;
  }
`;

const FIAT_CURRENCY_API = 'https://currencyconverter.cloud/api/fiat';

export default class CurrencyConverter extends Component {
  constructor() {
    super();
    this.state = {
      baseCurrency: { value: 'USD' },
      quoteCurrency: { value: 'EUR' },
      baseCurrencyValue: 1,
      quoteCurrencyValue: undefined,
      currencies: [],
      cheatCheetItems: [],
    };
    fx.base = this.state.baseCurrency;
  }

  componentDidMount = () => {
    axios
      .get(FIAT_CURRENCY_API)
      .then(result => {
        fx.rates = result.data.currencies;
        // We initialize cheatCheetItems as a callback so we can be certain
        // money.js has been loaded with currencies before we try to do any calculations
        // when rendering the cheat cheet table
        this.handleValueUpdate(
          this.setState({ cheatCheetItems: [5, 10, 25, 50, 100] })
        );
      })
      .catch(e => {
        console.log(e);
      });
  };

  updateBaseCurrency = baseCurrency => {
    this.setState({ baseCurrency: baseCurrency || '' }, () =>
      this.handleValueUpdate()
    );
  };

  updateQuoteCurrency = quoteCurrency => {
    this.setState({ quoteCurrency: quoteCurrency || '' }, () =>
      this.handleValueUpdate()
    );
  };

  updateBaseCurrencyValue = e => {
    this.setState({ baseCurrencyValue: e.target.value }, () =>
      this.handleValueUpdate()
    );
  };

  calculateQuoteCurrencyValue = value => {
    try {
      let result = fx(value)
        .from(this.state.baseCurrency.value)
        .to(this.state.quoteCurrency.value)
        .toFixed(4);
      return result;
    } catch (e) {
      console.log('calculate QuoteCurrencyValue failed', e);
      //throw e
    }
  };

  handleValueUpdate = (cb = () => {}) => {
    Promise.resolve(
      fx(this.state.baseCurrencyValue)
        .from(this.state.baseCurrency.value)
        .to(this.state.quoteCurrency.value)
        .toFixed(4)
    )
      .then(result => {
        this.setState({ quoteCurrencyValue: result }, cb());
      })
      .catch(e => {
        console.log('setstate Calculation failed', e);
      });
  };

  switcharoo = () => {
    this.setState(
      {
        baseCurrency: this.state.quoteCurrency,
        quoteCurrency: this.state.baseCurrency,
      },
      () => this.handleValueUpdate()
    );
  };

  renderTableRow = (amount, rowKey) => {
    return (
      <tr key={rowKey}>
        <td>
          {amount} {this.state.baseCurrency.value}
        </td>
        <td> = </td>
        <td>
          {this.calculateQuoteCurrencyValue(amount)}{' '}
          {this.state.quoteCurrency.value}
        </td>
      </tr>
    );
  };

  render() {
    return (
      <ConverterContainer>
        <ColorBox bg="#4db3a4" maxWidth="540px">
          <ControlsContainer>
            <FiatCurrencySelector
              defaultCurrency={this.state.baseCurrency}
              onFiatCurrencyChange={this.updateBaseCurrency}
            />
            <SwitcharooButton onClick={this.switcharoo}>
              <SwitcharooIconLeft />
              <SwitcharooIconRight />
            </SwitcharooButton>
            <FiatCurrencySelector
              defaultCurrency={this.state.quoteCurrency}
              onFiatCurrencyChange={this.updateQuoteCurrency}
            />
          </ControlsContainer>
          <FieldContainer>
            <CurrencyLabel>{this.state.baseCurrency.value}</CurrencyLabel>
            <CurrencyField
              type={'number'}
              value={this.state.baseCurrencyValue}
              onChange={this.updateBaseCurrencyValue}
              placeholder="Kirjoita määrä..."
            />
          </FieldContainer>
          <FieldContainer>
            <CurrencyLabel>{this.state.quoteCurrency.value}</CurrencyLabel>
            <QuoteCurrencyOutput>
              {isNaN(this.state.quoteCurrencyValue)
                ? '🙄'
                : this.state.quoteCurrencyValue}
            </QuoteCurrencyOutput>
          </FieldContainer>
        </ColorBox>

        <ColorBox bg="#fff">
          <AdSense.Google
            client="ca-pub-8539545767229830"
            slot="3711011234"
            style={{ display: 'block' }}
            format="auto"
          />
          <CheatCheetTitle>VALUUTTA AVAIN</CheatCheetTitle>
          <CurrencyTable>
            <tbody>
              {this.state.cheatCheetItems.map((value, i) =>
                this.renderTableRow(value, i)
              )}
            </tbody>
          </CurrencyTable>
        </ColorBox>
      </ConverterContainer>
    );
  }
}
